import React from 'react';
import './WhoWeAre.css';

function WhoWeAre() {
  return (
    <section id="who-we-are" className="who-we-are-section">
      <div className="container">
        <svg className="wellness-illustration" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="100" r="80" fill="#1976D2" opacity="0.2"/>
          <circle cx="100" cy="100" r="60" fill="#1565C0" opacity="0.3"/>
          <path d="M100,50 C85,50 80,60 80,70 C80,90 100,105 100,120 C100,105 120,90 120,70 C120,60 115,50 100,50 Z"
                fill="#1565C0"/>
          <circle cx="70" cy="80" r="15" fill="#1976D2" opacity="0.6"/>
          <circle cx="130" cy="80" r="15" fill="#1E88E5" opacity="0.6"/>
        </svg>

        <h2 className="section-title">About HashFusion Innovations</h2>
        <div className="content">
          <p className="description">
            HashFusion Innovations was founded by three college friends driven by a shared belief —
            that human health deserves smarter, more accessible, and more human-centered solutions.
          </p>
          <p className="description">
            We operate as a parent company that ideates, builds, and nurtures ventures across health,
            wellness, and human performance. Our approach blends technology, product thinking, business
            strategy, and deep empathy for real human problems.
          </p>
          <p className="description emphasis">
            We are long-term builders, not trend chasers.
          </p>
        </div>
      </div>
    </section>
  );
}

export default WhoWeAre;
